__turbopack_context__.v({
  "accordionSlideOverwrite": "styles-module-scss-module__X7AMEG__accordionSlideOverwrite",
  "button": "styles-module-scss-module__X7AMEG__button",
  "buttonContainer": "styles-module-scss-module__X7AMEG__buttonContainer",
  "buttonImage": "styles-module-scss-module__X7AMEG__buttonImage",
  "fadeIn": "styles-module-scss-module__X7AMEG__fadeIn",
  "fadeOut": "styles-module-scss-module__X7AMEG__fadeOut",
  "image": "styles-module-scss-module__X7AMEG__image",
  "scaleIn": "styles-module-scss-module__X7AMEG__scaleIn",
  "scaleOut": "styles-module-scss-module__X7AMEG__scaleOut",
  "zoomIn": "styles-module-scss-module__X7AMEG__zoomIn",
  "zoomOut": "styles-module-scss-module__X7AMEG__zoomOut",
});
